module.exports = __webpack_public_path__ + "img/welcomelanding_icon3.cf3b7e23.png";